import { useDispatch } from "react-redux";
import './Menu.scss';
import MenuButton from "../../components/MenuButton";
import { closeMenu, logout } from "../../store/generalSlice";

function Menu() {
    const dispatch = useDispatch();

    const onCloseClick = () => {
        dispatch(closeMenu());
    }

    const onQuitClick = () => {
        dispatch(logout());
    }

    return <div className="mafia-menu">
        <div className="menu-header">Menu</div>
        <button className="close-menu-button" onClick={onCloseClick}>X</button>
        <div className="menu-content">
            <MenuButton label="Game" route='/game' />
            <MenuButton label="Scenario Editor" route='/editor' />
            <MenuButton label="Quit Game" route='/game' onClicked={onQuitClick}/>
            <MenuButton label="Help" route='/help' />
        </div>
    </div>
}

export default Menu;